// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-page > .bolt-tabbar {
  padding: 0 32px 0 24px;
}
@media screen and (max-width: 599px) {
  .bolt-page > .bolt-tabbar {
    padding-left: 12px;
    padding-right: 20px;
  }
}
.bolt-page > .bolt-header {
  padding-top: 24px;
  padding-bottom: 0px;
  margin-left: 12px;
  margin-right: 12px;
}
@media screen and (max-width: 599px) {
  .bolt-page > .bolt-header {
    padding-top: 16px;
    margin-left: 0;
    margin-right: 0;
  }
}
.bolt-page > .bolt-header {
  z-index: 3;
}
.bolt-page > .bolt-header .bolt-header-commandbar-no-right-padding {
  padding-right: 4px;
}
@media screen and (max-width: 599px) {
  .bolt-page > .bolt-header .bolt-header-commandbar-no-right-padding {
    padding-right: 0;
  }
}
.bolt-page > .vss-FilterBar {
  margin-left: 32px;
  margin-right: 32px;
}
.bolt-page .page-content {
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 16px;
}
@media screen and (max-width: 599px) {
  .bolt-page .page-content {
    padding-left: 0;
    padding-right: 0;
  }
}
.bolt-page .page-content-top {
  padding-top: 16px;
}
.bolt-page .page-content-bottom {
  padding-bottom: 16px;
}
.bolt-page .page-content-left {
  padding-left: 32px;
}
@media screen and (max-width: 599px) {
  .bolt-page .page-content-left {
    padding-left: 0;
  }
}
.bolt-page .page-content-right {
  padding-right: 32px;
}
@media screen and (max-width: 599px) {
  .bolt-page .page-content-right {
    padding-right: 0;
  }
}

.bolt-page-grey {
  background-color: rgba( 248, 248, 248 ,  1 );
  background-color: rgba( var(--palette-neutral-2,248, 248, 248) ,  1 );
}

.bolt-page-white {
  background-color: rgba(255, 255, 255, 1);
  background-color: var(--background-color,rgba(255, 255, 255, 1));
}

/*# sourceMappingURL=Page.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Page/Page.scss","webpack://./../azure-devops-ui/bin/Components/Page/Page.css","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AAQI;EACI,sBAAA;ACPR;AC8VI;EFxVA;IAKQ,kBAAA;IACA,mBAAA;ECPV;AACF;ADUI;EAII,iBAAA;EACA,mBAAA;EAEA,iBEgSK;EF/RL,kBE+RK;AD3Sb;ACkVI;EF9UA;IAYQ,iBE+RC;IF9RD,cAAA;IACA,eAAA;ECZV;AACF;ADHI;EAqBI,UAAA;ACfR;ADkBQ;EACI,kBEsQA;ADtRZ;ACqUI;EFtTI;IAKQ,gBAAA;EChBd;AACF;ADoBI;EACI,iBEmRK;EFlRL,kBEkRK;ADpSb;ADuBI;EACI,kBE4QK;EF3QL,mBE2QK;EF1QL,oBE+PK;ADpRb;ACuTI;EFrSA;IAOQ,eAAA;IACA,gBAAA;ECrBV;AACF;AD0BI;EACI,iBEmPK;AD3Qb;AD6BI;EACI,oBE6OK;ADxQb;ADgCI;EACI,kBEkPK;ADhRb;ACwSI;EF3QA;IAIQ,eAAA;EC7BV;AACF;ADkCI;EACI,mBEwOK;ADxQb;ACgSI;EFjQA;IAIQ,gBAAA;EC/BV;AACF;;ADmCA;EACI,4CEbQ;EDnBV,qEAAqE;AACvE;;AAEA;EACE,wCAAwC;EACxC,gEAAgE;AAClE;;AAEA,mCAAmC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
